import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const ThumbsUpSolid = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M4.37092 10.792C4.12301 10.792 3.89259 10.6543 3.80217 10.4233C3.60194 9.91365 3.49943 9.37084 3.50001 8.82324C3.50001 7.80241 3.84942 6.86441 4.43451 6.12008C4.52259 6.00808 4.65209 5.93983 4.78451 5.88849C5.06042 5.78174 5.30367 5.58866 5.49151 5.34949C5.94433 4.77178 6.51276 4.29495 7.16042 3.94949C7.58217 3.72549 7.94792 3.39183 8.12467 2.94908C8.24881 2.63889 8.31256 2.30785 8.31251 1.97374V1.60449C8.31251 1.48846 8.3586 1.37718 8.44065 1.29513C8.52269 1.21309 8.63397 1.16699 8.75001 1.16699C9.0981 1.16699 9.43194 1.30527 9.67808 1.55141C9.92422 1.79756 10.0625 2.1314 10.0625 2.47949C10.0625 3.15149 9.91084 3.78791 9.64076 4.35666C9.48559 4.68216 9.70317 5.10449 10.0637 5.10449H11.8872C12.4857 5.10449 13.0218 5.50933 13.0853 6.10491C13.1116 6.35108 13.125 6.60074 13.125 6.85449C13.1274 8.45069 12.582 9.99938 11.5798 11.2417C11.3534 11.5229 11.004 11.667 10.6435 11.667H8.30084C8.01909 11.667 7.73851 11.6215 7.47076 11.5328L5.65426 10.9262C5.38657 10.8371 5.10628 10.7918 4.82417 10.792H4.37092Z" />;
    t2 = <path d="M1.35976 6.25774C1.03829 7.07482 0.873834 7.9452 0.875006 8.82324C0.874269 9.51642 0.976496 10.2059 1.17834 10.869C1.33001 11.3648 1.81126 11.667 2.32984 11.667H2.85834C3.11792 11.667 3.27834 11.3765 3.16342 11.1432C2.80767 10.4216 2.62322 9.62772 2.62442 8.82324C2.62442 7.82691 2.90209 6.89533 3.38392 6.10141C3.52684 5.86633 3.36759 5.54199 3.09226 5.54199H2.47917C1.99384 5.54199 1.53826 5.80624 1.35976 6.25774Z" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="solid" viewBox="-1 -1 16 16">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { ThumbsUpSolid };